import { useDispatch } from 'react-redux';
import GlobalIssuesSubnav from '../../subnavs/GlobalIssuesHeader';
import NavigationStore from '../../../../redux/navigation';
import { useOnMount } from '../../../../hooks';
import type { Scope } from '../../../../../shared/issuesV2';

/**
 * Hook which is responsible for dispatching an action to the NavigationStore,
 * so that it displays + renders the correct subnav for Issues.
 * This is only applicable to the global issues dashboard, as the subnav
 * is already handled in projects by a parent component.
 *
 * @param {Scope} scope - The current Scope (ie: "global", "project" or "releaseGroups").
 */
const useIssuesSubnav = (scope: Scope) => {
  const dispatch = useDispatch();
  //  Note that we cannot useDispatchOnMount because of the conditional.
  useOnMount(() => {
    if (scope.type === 'global') {
      dispatch(
        NavigationStore.actions.setNavState({
          expand: 'project-expanded',
          subnav: GlobalIssuesSubnav,
          navProps: {
            showBranchDropdown: true,
            shouldUseCallToAction: true,
          },
        }),
      );
    }
  });
};

export default useIssuesSubnav;
